import Spline from '@splinetool/react-spline';

const Animations = () => {
  return (
    <Spline scene="https://prod.spline.design/zplM6z0ZakHWOuzo/scene.splinecode" />
  )
}

export default Animations